import React from "react";
import ForwardingBatch from "../Pages/Forwarding/ForwardingBatch";
import ForwardingBatches from "../Pages/Forwarding/ForwardingBatches";
import Mailboxes from "../Pages/Mail/Mailboxes";
import MailItem from "../Pages/Mail/MailItem";
import ForwardingBatchProvider from "../Providers/ForwardingBatchProvider";
import {SuggestibleRouteInterface} from "./TopRoutes";

const MailRoutes: Array<SuggestibleRouteInterface> = [
    {
        title: 'Mailboxes',
        path: '/mail/:folderSlug?',
        element:
            <Mailboxes />
    },
    {
        title: 'Forwarding Batches',
        path: '/mail/forwarding-batches',
        element:
            <ForwardingBatches />
    },
    {
        title: 'Forwarding Batches',
        path: '/mail/forwarding-batches/:batchId',
        element:
            <ForwardingBatchProvider>
                <ForwardingBatch />
            </ForwardingBatchProvider>
    },
    {
        title: 'Search Mail',
        path: '/mail-search',
        element:
            <Mailboxes isSearch={true} />
    },
    {
        title: 'Custom Folder',
        path: '/mail/custom-folder/:clientFolderIds',
        element:
            <Mailboxes />
    },
    {
        title: 'Tagged Mail Items',
        path: `/mail/tagged/:mailTagIds`,
        element:
            <Mailboxes />
    },
    {
        title: 'Mail Item',
        path: `/mail/:folderSlug/:mailId`,
        element:
            <MailItem />
    },
    {
        title: 'Mail Item',
        path: `/mail/forwarding-batches/mail-item/:mailId`,
        element:
            <MailItem />
    },
    {
        title: 'Mail Item',
        path: `/mail/custom-folder/:customFolderId/:mailId`,
        element:
            <MailItem />
    },
]

export default MailRoutes
